import EveryMood from "@/components/Icon/EveryMood";
import FabFood from "@/components/Icon/FabFood";
import Payment from "@/components/Icon/Payment";
import Tracking from "@/components/Icon/Tracking";
import { AVATAR_DEFAULT_SRC } from "@/constants/assets";
import { downloadAppStoreUrl, downloadGooglePlayStoreUrl } from "@/utils";

const base_url = 'https://imgcdn.kuick.com/kuickwebsiteimg';

export const landingPageContents = {
	TagsAccordion: [
		{
			title: 'Popular tags near me',
			dataIndex: 1,
			toggle: '1'
		},
		{
			title: 'Popular offers near me',
			dataIndex: 2
		},
		{
			title: 'Popular cuisines near me',
			dataIndex: 0
		}
	],
	ChooseOurFavFoodItems: [
		{
			Icon: EveryMood,
			heading1: 'Food For',
			heading2: 'EVERY MOOD',
			description: 'From high street favs to your local regulars, we have got it all! Want it? Kuick it.'
		},
		{
			Icon: FabFood,
			heading1: 'Select Your',
			heading2: 'FAB FOOD',
			description: 'Now adding your favourite dishes to the cart is Kuick-er. More time for Netflix!'
		},
		{
			Icon: Payment,
			heading1: 'Make Your',
			heading2: 'PAYMENT',
			description: 'You can use coupons, loyalty points & wallet to make payments. Easy-Peasy right?'
		},
		{
			Icon: Tracking,
			heading1: 'Live Order',
			heading2: 'TRACKING',
			description: 'Track your order at every step of the way. Ignorance is no more bliss!'
		}
	],

	Testimonials: [
		{
			id: 1,
			name: 'Aarav Mehta',
			designation: 'Food Blogger',
			contentTemplate:
				'I use {WEBSITE_TYPE} almost every day! The delivery is super quick, the ordering process is seamless, and the food always arrives hot. {WEBSITE_TYPE} has genuinely upgraded my everyday meals.',
			image: AVATAR_DEFAULT_SRC
		},
		{
			id: 2,
			name: 'Sophia Martinez',
			designation: 'Marketing Director',
			contentTemplate:
				'{WEBSITE_TYPE} has become my go-to for office lunches and weekend dinners. The experience is effortless, and the menu options are fantastic. Highly recommended!',
			image: AVATAR_DEFAULT_SRC
		},
		{
			id: 3,
			name: 'Rahul Sengupta',
			designation: 'Entrepreneur',
			contentTemplate:
				'What I love most about {WEBSITE_TYPE} is the reliability. Fresh food, timely deliveries, and exceptional service—every single time. It’s the perfect solution for busy professionals like me.',
			image: AVATAR_DEFAULT_SRC
		}
	],
	StatsData: [
		{
			value: '10K+',
			description: `Satisfied Customers \n All Great Over The World`
		},
		{
			value: '4M',
			description: `Healthy Dishes Sold \n Including Milk Shakes Smooth`
		},
		{
			value: '99.99%',
			description: `Reliable Customer Support \n We Provide Great Experiences`
		}
	],
	StoreLinks: [
		{
			name: 'Google Play',
			href: downloadGooglePlayStoreUrl,
			img: `${base_url}/landing_page/googleplay.png`
		},
		{
			name: 'App Store',
			href: downloadAppStoreUrl,
			img: `${base_url}/landing_page/appstore.png`
		}
	]
};